import { baseUrl } from '@util/assets'

export const getPlaceholderProfileImageUrl = (gender: TGender): string =>
    `${baseUrl}images/placeholder/profile/${gender}-250x250.png`
